export const statusesOptions = [
  { value: "ACTIVE", label: "Aktywny" },
  { value: "NEW", label: "Nowy" },
  { value: "CREATED", label: "Stworzony" },
  { value: "AWAITING_ACTIVATION", label: "Oczekuje na aktywację" },
  { value: "CANCELED", label: "Anulowany" },
  { value: "RESIGNED", label: "Zrezygnowany" },
];

export const typeOptions = [
  { value: "POINTS_BANK", label: "Koszt z BP" },
  { value: "ONLINE_PAYMENT", label: "Płatność online" },
  { value: "SALARY_DEDUCTION", label: "Koszt pracownika" },
  { value: "FOR_FREE", label: "Rozliczane przez pracodawcę" },
  { value: "HIDDEN_EMPLOYER_COST", label: "Ukryty koszt pracodawcy" },
  { value: "EMPLOYER", label: "Pracodawca" },
];

export const periodStatusOptions = [
  { value: "PAID", label: "Opłacony" },
  { value: "UNPAID", label: "Oczekujący" },
  { value: "ADVANCE", label: "Oczekujący" },
  { value: "REFUNDED", label: "Zwrócony" },
  { value: "CANCELED", label: "Anulowany" },
];

export const operationTypeOptions = [
  { value: "PAYMENT", label: "Płatność" },
  { value: "REFUND", label: "Zwrot" },
];

export const financingSourceTypeOptions = [
  { value: "POINTS_BANK", label: "Koszt z BP" },
  { value: "ONLINE_PAYMENT", label: "Płatność online" },
  { value: "SALARY_DEDUCTION", label: "Koszt pracownika" },
  { value: "FOR_FREE", label: "Rozliczane przez pracodawcę" },
  { value: "HIDDEN_EMPLOYER_COST", label: "Ukryty koszt pracodawcy" },
  { value: "EMPLOYER", label: "Pracodawca" },
];

export const paymentMethodTypeOptions = [
  { value: "CHARGE_TO_CHARGE", label: "Od doładowania do doładowania" },
  { value: "PERIOD_TO_PERIOD", label: "Z miesiąca na miesiąc" },
  { value: "FINANCIAL_YEAR", label: "Do końca roku obrachunkowego" },
];

export const operationStatusOptions = [
  { value: "NEW", label: "Nowa" },
  { value: "PAID", label: "Zapłacona" },
  { value: "REFUNDED", label: "Zwrócona" },
  { value: "WAITING", label: "Oczekująca" },
  { value: "ADVANCE", label: "Oczekująca" },
  { value: "RESERVATION", label: "Zarezerwowana" },
  { value: "CANCELED", label: "Anulowana" },
  { value: "DONE", label: "Zakończona" },
];

export const onlinePaymentMethodTypeOptions = [
  { value: "PAY_BY_CARD", label: "Karta" },
  { value: "PAY_BY_LINK", label: "Link" },
  { value: "PAY_BY_BLIK", label: "BLIK cykliczny" },
  { value: "PAY_BY_APPLE", label: "Apple Pay" },
  { value: "PAY_BY_GOOGLE", label: "Google Pay" },
];

export const cancellationReasonOptions = [];

export const OperatorsMapper = {
  contains: "=like=",
  doesNotContain: "=notlike=",
  equals: "==",
  is: "==",
  "=": "==",
  doesNotEqual: "!=",
  not: "!=",
  "!=": "!=",
  after: "=gt=",
  ">": "=gt=",
  onOrAfter: "=ge=",
  ">=": "=ge=",
  before: "=lt=",
  "<": "=lt=",
  onOrBefore: "=le=",
  "<=": "=le=",
  // startsWith: '', // not implemented
  // endsWith: '', // not implemented
  // isEmpty: '', // not implemented
  // isNotEmpty: '', // not implemented
  isAnyOf: "=in=",
  // isNotAnyOf: "=out=", // not implemented
};

export const stringOperators = [
  "contains", // "=like="
  "doesNotContain", // "=notlike="
  "equals", // "=="
  "doesNotEqual", //  "!="
  // "startsWith", // not implemented
  // "endsWith", // not implemented
  // "isEmpty", // not implemented
  // "isNotEmpty", // not implemented
  // "isAnyOf", // "=in=" // not implemented
  // "isNotAnyOf", // "=out=" // not implemented
];

export const numericOperator = [
  "=", // "=="
  "!=", // "!="
  ">", // "=gt=", ">"
  ">=", //  "=ge=", ">="
  "<", // "=lt=", "<"
  "<=", // "=le=", "<="
  // "isEmpty", // not implemented
  // "isNotEmpty", // not implemented
  // "isAnyOf", // "=in=" // not implemented
  // "isNotAnyOf", // "=out=" // not implemented
];

export const dateOperators = [
  "is", // "=="
  "not", // "!="
  "after", // "=gt=", ">"
  "onOrAfter", // "=ge=", ">="
  "before", // "=lt=", "<"
  "onOrBefore", // "=le=", "<="
  // "isEmpty", // not implemented
  // "isNotEmpty", // not implemented
  // "isAnyOf", // "=in=" // not implemented
  // "isNotAnyOf", // "=out=" // not implemented
];

export const dateTimeOperators = [
  "is", // "=="
  // "not", // "!=" // not implemented
  "after", // "=gt=", ">"
  "onOrAfter", // "=ge=", ">="
  "before", // "=lt=", "<"
  "onOrBefore", // "=le=", "<="
  // "isEmpty", // not implemented
  // "isNotEmpty", // not implemented
  // "isAnyOf", // "=in=" // not implemented
  // "isNotAnyOf", // "=out=" // not implemented
];

export const booleanOperators = [
  "is", // "=="
  "not", // "!="
];

export const DEFAULT_PAGE_SIZE = 10;
